export default "__VITE_ASSET__DKA2Eq4d__"